import type { EnhancedLiveChatConfig } from '#types/config/integrations/livechat'

export default {
  cssPath: '/livechat/css/LiveChatCodeCanvasTNF.css',
  brand: 'TNF',
  languageConfig: {
    'cs-cz': 'en_US',
    'da-dk': 'en_US',
    'de-at': 'de',
    'de-be': 'de',
    'de-ch': 'de',
    'de-lu': 'de',
    'el-gr': 'en_US',
    'en-cz': 'en_US',
    'en-dk': 'en_US',
    'en-fi': 'en_US',
    'en-gr': 'en_US',
    'en-ie': 'en_US',
    'en-lu': 'en_US',
    'en-no': 'en_US',
    'en-se': 'en_US',
    'fr-be': 'fr',
    'fr-ch': 'fr',
    'fr-fr': 'fr',
    'fr-lu': 'fr',
    'it-ch': 'it',
    'it-it': 'it',
    'nl-be': 'nl_NL',
    'nl-nl': 'nl_NL',
    'no-no': 'en_US',
    'pl-pl': 'pl',
    'pt-pt': 'pt_PT',
    'sv-fi': 'en_US',
    'sv-se': 'en_US'
  },
  eswConfigDevName: 'MIAW_TNF'
} satisfies EnhancedLiveChatConfig
